// 根据最后一级id获取所有父级id（包含最后一级）
export default function getFullByLastIdFromTree(arr, id) {
  let res = [id]
  getParentId(res, arr, id)
  return res
}

function getParentId(res, arr, id) {
  let filterRes = arr.find((i) => i.id === id)
  if (filterRes) {
    if (filterRes.pid > 0) {
      res.unshift(filterRes.pid)
      getParentId(res, arr, filterRes.pid)
    }
  }
}
